import { render, staticRenderFns } from "./campaignproducts.vue?vue&type=template&id=e05b7294&"
import script from "./campaignproducts.vue?vue&type=script&lang=js&"
export * from "./campaignproducts.vue?vue&type=script&lang=js&"
import style0 from "./campaignproducts.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports